import { render, staticRenderFns } from "./AccountProfileOrderHistory.vue?vue&type=template&id=0cf79cfc&"
import script from "./AccountProfileOrderHistory.vue?vue&type=script&lang=js&"
export * from "./AccountProfileOrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports